import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const DisableConfirmDialog = ({ open, loading, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby='disable-dialog-title'
      aria-describedby='disable-dialog-description'
    >
      <DialogTitle id='disable-dialog-title' display='flex' alignItems='center' gap={1}>
        <WarningAmberIcon color='warning' />
        Disable Webhook Registration
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='disable-dialog-description'>
          Disabling this registration will stop all future callbacks to this endpoint. Are you sure?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading} autoFocus>
          Cancel
        </Button>
        <Button
          variant='contained'
          color='warning'
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(DisableConfirmDialog);
